import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './CategorySlider.css';

const CategorySlider = () => {

  const categories = [
    {
      id: 'software-development',
      title: 'Software Development',
      description: 'Custom software development services delivering innovative solutions across various industries and technological platforms.',
      link: 'RAYAD SOFTWARE',
      href: '/portfolio/software-development',
      color: 'software-development'
    },
    {
      id: 'cyber-security',
      title: 'Cyber Security',
      description: 'Advanced cybersecurity solutions protecting businesses from digital threats with cutting-edge AI and ML-powered security intelligence tools.',
      link: 'RAYAD CYBER SECURITY',
      href: '/portfolio/cybersecurity',
      color: 'cyber-security'
    },
    {
      id: 'blockchain-trading',
      title: 'Blockchain & Crypto',
      description: 'Professional cryptocurrency trading and blockchain technology development services for institutional and individual investors.',
      link: 'RAYAD BLOCKCHAIN',
      href: '/portfolio/blockchain-seed-investment',
      color: 'blockchain-trading'
    },
    {
      id: 'intrusion-detection',
      title: 'Electronic Intrusion Detection',
      description: 'Advanced electronic intrusion detection sensors providing comprehensive security monitoring and threat assessment capabilities.',
      link: 'RAYAD INTRUSION DETECTION',
      href: '/portfolio/intrusion-detection',
      color: 'intrusion-detection'
    },
    {
      id: 'education',
      title: 'Techucation',
      description: 'Educational technology solutions combining traditional learning with modern digital tools to create innovative educational experiences.',
      link: 'RAYAD EDUCATION',
      href: '/portfolio/education',
      color: 'education'
    },
    {
      id: 'biotech',
      title: 'Biotech & Longevity',
      description: 'Investment and development in biotechnology and longevity research, supporting breakthrough medical solutions and patient care.',
      link: 'RAYAD BIOTECH',
      href: '/portfolio/biotech',
      color: 'biotech'
    },
    {
      id: 'immigration',
      title: 'Immigration Services',
      description: 'Comprehensive immigration solutions and legal services for individuals and businesses seeking to navigate complex immigration processes.',
      link: 'RAYAD IMMIGRATION SERVICES',
      href: '/portfolio/immigration',
      color: 'immigration'
    },
    {
      id: 'corporate-services',
      title: 'Corporate Services',
      description: 'Strategic business consulting and corporate advisory services helping companies achieve operational excellence and sustainable growth.',
      link: 'RAYAD CORPORATE SERVICES',
      href: '/portfolio/corporate-services',
      color: 'corporate-services'
    },
    {
      id: 'business-advisory',
      title: 'Business Advisory',
      description: 'Comprehensive business and financial advisory services helping companies make strategic decisions and achieve their objectives.',
      link: 'RAYAD BUSINESS ADVISORY',
      href: '/portfolio/event',
      color: 'business-advisory'
    },
    {
      id: 'contemporary-art',
      title: 'Emirati & Contemporary Art',
      description: 'MRK Contemporary Art Gallery showcasing innovative artistic works and supporting emerging artists in the contemporary art scene.',
      link: 'MRK CONTEMPORARY ART',
      href: '/portfolio/art',
      color: 'contemporary-art'
    }
  ];

  return (
    <section className="distinct-solutions-section">
      <div className="category-slider-container">
        {/* Top decorative line */}
        <div className="decorative-line decorative-line-top"></div>
        
        <div className="section-header">
          <div className="header-content">
            <h2 className="main-section-title">
              Distinct Solutions,<br />Personal Service
            </h2>
            <p className="main-section-description">
              We serve families and individuals, institutional investors, and corporations across a wide range of needs and objectives. We continue to learn from our heritage and seek out new and innovative ways of working, using our past success to help us continue pioneering the future of business and technology.
            </p>
          </div>
          {/* Bottom decorative line */}
          <div className="decorative-line decorative-line-bottom"></div>
        </div>

        <div className="swiper-container">
          <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={20}
            slidesPerView={3}
            slidesPerGroup={3}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            speed={600}
            grabCursor={true}
            touchRatio={1}
            touchAngle={45}
            threshold={10}
            breakpoints={{
              320: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 20,
              },
            }}
            className="category-swiper"
          >
            {categories.map((category) => (
              <SwiperSlide key={category.id}>
                <div className={`card ${category.color}`}>
                  <a href={category.href} className="card-link">
                    <div className="card-content">
                      <h3 className="card-title">{category.title}</h3>
                      <div className="card-divider"></div>
                      <p className="card-description">{category.description}</p>
                      <span className="card-link-text">
                        {category.link}
                        <span className="arrow">→</span>
                      </span>
                    </div>
                  </a>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default CategorySlider;